import { useParams } from 'react-router-dom'
import { useMemo } from 'react'

import { Hooks } from 'service-api'
import { isoTodayTZ } from 'components-ui/src/shared/dates'
import { useLocationContext } from '@providers/location'
import { formatUnusedVouchers } from 'components-ui/src/shared/vouchers'

const UNUSED_VOUCHERS_REPORT = 'unused-voucher-offer-count-by-date-v2'

export const useVouchersBalance = (lupId: string, props: { cacheEnabled?: boolean }) => {
  const { accountName: locationName = '' } = useParams()
  const { cacheEnabled = false } = props || {}
  const location = useLocationContext()

  const { data: unusedVouchers, isFetching } = Hooks.useClientReports(
    locationName,
    lupId,
    UNUSED_VOUCHERS_REPORT,
    { filter: { date: isoTodayTZ(location.location?.timezone ?? undefined) } },
    { cacheEnabled, enabled: !!lupId }
  )

  const groupedByLSTAndVoucher = useMemo(() => formatUnusedVouchers(unusedVouchers), [unusedVouchers])

  return {
    unusedVouchers: {
      total: unusedVouchers?.total || 0,
      items: Object.values(groupedByLSTAndVoucher).sort((a, b) => b.value - a.value),
    },
    isFetching,
  }
}
